import { createFlow } from "../api";
import {
  Title,
  TextInput,
  Button,
  Container,
  Textarea,
  Stack,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useLocation } from "wouter";

export default function FlowCreate() {
  const [, setLocation] = useLocation();

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      title: "",
      description: "",
      slug: "",
    },
    validate: {
      //emailAddress: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
      //tenantSlug: (val) => (/^[a-z][a-z0-9_-]+$/.test(val) ? null : "Invalid slug"),
    },
  });

  return (
    <Container size="sm">
      <Title order={1} mb="md">
        Create New Flow
      </Title>

      <form
        onSubmit={form.onSubmit((values) => {
          createFlow(values).then(() => {
            setLocation("/flows");
          });
        })}
      >
        <Stack>
          <TextInput
            label="Title"
            description="A human-readable name for this flow, shown in the dashboard and logs"
            placeholder="Document analysis"
            {...form.getInputProps("title")}
            radius="md"
          />

          {/* <TextInput
          label="Flow Slug"
          {...form.getInputProps("slug")}
          radius="md"
        /> */}

          <Textarea
            label="Description"
            description="Optional notes about the purpose and usage of this flow"
            autosize
            minRows={2}
            maxRows={5}
            placeholder="Prompts related to analysis of SEC standard publications"
            {...form.getInputProps("description")}
            radius="md"
          />

          <Button mt="lg" type="submit">
            Create
          </Button>
        </Stack>
      </form>
    </Container>
  );
}
